/**
 * @file IconClose Icon
 * @author Auto Generated by @polyv/icons-cli
 */

import { IconBuilder } from '@polyv/icons-vue/icon-builder';

export default IconBuilder(
  'icon-close',
  (data) => `
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg
  width="${data.size}"
  height="${data.size}"
  class="icon"
  p-id="33106"
  t="1681981360226"
  viewBox="0 0 1024 1024"
>
  <path
    fill="${data.colorDesc[0]}"
    d="M800.682667 880.896l80.981333-80.981333-275.285333-273.749334 275.285333-274.517333L801.450667 170.666667 525.397333 445.952 251.733333 170.666667 170.666667 250.88l275.968 275.285333L170.666667 799.914667l81.066666 81.066666 273.664-275.285333z"
    p-id="33107"
  />
</svg>
`
);
